import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { loadTree } from "./loadTree";
import sidebarHelper from "../../../helpers/sidebar";
import ImageBrandHilite from "./ImageBrandHilite";
import TicketMenu from "./TicketMenu";
import FinanceMenu from "./FinanceMenu";
import SitePublisherMenu from "./SitePublisherMenu";
import CampaignMenu from "./CampaignMenu";
import AdvertiseMenu from "./AdvertiseMenu";
import CoworkerCustomerFinanceMenu from "./CoworkerCustomerFinanceMenu";

export default function Sidebar({ openItem = null, activeItem = null }) {
  useEffect(() => {
    loadTree();
  }, []);

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <ImageBrandHilite />

      <div className="sidebar" id="sidebar" style={{ direction: "rtl" }}>
        <div style={{ direction: "rtl" }}>
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link
                  to="/"
                  className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "welocome"
                      )} `}
                >
                  <i className="nav-icon hl-panel"></i>
                  <p>میزکار</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/user/all-customer-coworker"
                  className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(activeItem, "users")} `}
                >
                  <i className="nav-icon fa fa-users"></i>
                  <p>کاربران</p>
                </Link>
              </li>
              <CampaignMenu activeItem={activeItem} />
              <AdvertiseMenu openItem={openItem} activeItem={activeItem} />
              <SitePublisherMenu activeItem={activeItem} />
              <FinanceMenu openItem={openItem} activeItem={activeItem} />
              <CoworkerCustomerFinanceMenu
                openItem={openItem}
                activeItem={activeItem}
              />
              <TicketMenu openItem={openItem} activeItem={activeItem} />
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
}
